import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "Notice"
});
const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M18.6468 10.09C18.6468 6.39976 15.6553 3.4082 11.965 3.4082C8.27476 3.4082 5.2832 6.39976 5.2832 10.09V18.6809H18.6468V10.09ZM7.1967 9.88299C7.3051 7.34313 9.39848 5.31729 11.965 5.31729L12.1721 5.3217C14.7119 5.4301 16.7377 7.52348 16.7377 10.09V16.7718H7.19229V10.09L7.1967 9.88299Z",
  fill: "white"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ createElementVNode("rect", {
  x: "3.375",
  y: "16.7734",
  width: "17.1818",
  height: "1.90909",
  rx: "0.5",
  fill: "white"
}, null, -1);
const _hoisted_4 = /* @__PURE__ */ createElementVNode("path", {
  d: "M14.8288 19.6364C14.8288 21.2179 13.5467 22.5 11.9652 22.5C10.3837 22.5 9.10156 21.2179 9.10156 19.6364H14.8288Z",
  fill: "white"
}, null, -1);
const _hoisted_5 = /* @__PURE__ */ createElementVNode("rect", {
  x: "10.5332",
  y: "1.5",
  width: "2.86364",
  height: "3.81818",
  rx: "1.43182",
  fill: "white"
}, null, -1);
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_6);
}
var notice = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { notice as default };
